/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{resolveVariantFromProps as t}from"./resolve-variants.js";function o(o,r,n){const e=o.getProps();return t(e,r,void 0!==n?n:e.custom,function(t){const o={};return t.values.forEach(((t,r)=>o[r]=t.get())),o}(o),function(t){const o={};return t.values.forEach(((t,r)=>o[r]=t.getVelocity())),o}(o))}export{o as resolveVariant};
//# sourceMappingURL=resolve-dynamic-variants.js.map
